import { use } from 'react';
import { SiteNoticeContext, type SiteNoticeContextValue } from '../site-notice-context';

export const useSiteNotices = (): SiteNoticeContextValue => {
  return use(SiteNoticeContext);
};
